/*
 *
 *  #region Copyright (c), Crompton Greaves Consumer Electricals Ltd.
 *  Crompton R&D IoT Department Proprietary Software
 *
 *  This file is part of Crompton Smart Home SDK
 *  Copyright (c) 2024 Crompton Greaves Consumer Electricals Ltd. All rights reserved.
 *  Contact: CROMPTON DEVELOPER SUPPORT <iot.platform@crompton.co.in>
 *
 *  This software, including documentation, is protected by copyright by
 *  Crompton Greaves Consumer Electricals Ltd. All rights are reserved. Copying, including reproducing, storing,
 *  adapting or translating, any or all of this material requires the prior written consent of
 *  Crompton Greaves Consumer Electricals Ltd. This material also contains confidential information which should not
 *  be disclosed to others without the prior written consent of Crompton Greaves Consumer Electricals Ltd.
 *
 *  Filename :
 *  * Created on: <Date>
 *  Author    :
 *  * #endregion
 * /
 *
 */
import React from 'react';
import TablePagination from '@mui/material/TablePagination';
import styled from '@emotion/styled';

const StyledPaginationContainer = styled(TablePagination)`
  /* Add your custom styles here */
  /* Add styles for other elements as needed (rowsPerPage, etc.) */
`;

const CustomPagination = ({ ...props }) => {
    return <StyledPaginationContainer {...props} />;
};

export default CustomPagination;